import script from "./PodcastsBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PodcastsBlockSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./PodcastsBlockSkeleton.vue?vue&type=style&index=0&id=4c139ccc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c139ccc"]])

export default __exports__